import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpService } from '../services/http.service';
import { GlobalService } from '../services/global.service';
import { configs } from '../configs/app.config';
import { ActivatedRoute } from '@angular/router';
import { borderTopRightRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public errorMessage: string;
  public successMessage: string;
  public warningMessage: string;
  resetPassword: FormGroup;
public queryParams:Object={};
  constructor(private ngxService: NgxUiLoaderService,private activatedRoute:ActivatedRoute, public globalService: GlobalService, private formBuilder: FormBuilder,
    public httpService: HttpService) {
    this.resetPassword = this.formBuilder.group({
      password: [''],
      confirmPassword: [''],
    })
    this.activatedRoute.queryParams.subscribe((res)=>{
this.queryParams=res;
    })
  }


  ngOnInit() { }
public passwordMatched:boolean=false;
public submitted:boolean=false;

  public UpdateUserProfile(): void {
   this.submitted=true;
    if(this.resetPassword['controls']['password']['value']!=='' && this.resetPassword['controls']['password']['value']===this.resetPassword['controls']['confirmPassword']['value'])
    this.passwordMatched=true;
    else{
    this.passwordMatched=false;
  return;}
    this.ngxService.start();
    this.httpService.createPostRequest(configs['api']['resetPassword'], {
      "verificationCode": this.queryParams['id'],
      "type":this.queryParams['type'],
      "password": this.resetPassword['controls']['password']['value'],
      "confirmPassword":this.resetPassword['controls']['confirmPassword']['value']}, '')
      .subscribe((res) => {
        this.ngxService.stop();
        this.successMessage = "Updated Successfully "
        setTimeout(() => {
          this.forPopupClose();
        }, 3000);
      }, (error) => {
        this.ngxService.stop();
        this.errorMessage = error && error['error'] && error.error['statusMessage'] &&
          (error.error['statusCode'] && error.error['statusCode'] !== 406) ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 2000);
      });
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
  }

}

